module.exports = __webpack_public_path__ + "static/media/heart-monitor.7bbee8e4.svg";